// https://vuex.vuejs.org/en/state.html
import { workflow } from 'theagent-status';

export default {
  status: workflow,
  medias: [],
  marketplaces: {},
  media: {},
};
